function menuPolicy() {
    const container = document.querySelector('.policy__content-box');

    if (!container) {
        return
    }

    const { childNodes } = container;
    const titles = [];

    childNodes.forEach((node) => {
        if (['H2', 'H3', 'H4'].includes(node.tagName)) {
            // add an anchor to the title
            let str = node.innerText.replace(/[^\w\s]|_/g, "").replace(/\s+/g, " "),
                anchorText = str.toLowerCase().split(' ').join('-'),
                anchorTag = document.createElement('a');

            // let slicedTitle = anchorText.replace(/[0-9]/g, '').slice(1);
            // .replace(/[0-9]/g, '').split('.').join("")
           //
           // dl.log(slicedTitle);

            anchorTag.id = anchorText;

            if (anchorText !== '') {
                node.prepend(anchorTag);
            }

            const anchor = node.querySelector('a[id]');

            if (anchor) {
                titles.push(node);
            }
        }
    });

    let html = '<ul class="policy__menu">';
    let open = false;

    for (let i = 0; titles.length > i; i++) {
        const title = titles[i];
        const anchor = title.querySelector('a[id]');

        let item = '';

        if (open && title.tagName === 'H2') {
            item += '</ul></li>';
            open = false;
        }

        item += `
            <li data-tag="${title.tagName}" data-id="${anchor.getAttribute('id')}">
                <a href="#${anchor.getAttribute('id')}">
                    ${title.innerText}
                </a>
            `;

        if (typeof titles[i + 1] !== 'undefined') {
            if (title.tagName === 'H2' && titles[i + 1].tagName !== 'H2') {
                item += '<ul>';
                html += item;
                open = true;

                continue;
            }
        }

        item += '</li>';
        html += item;
    }

    if(open) {
        html += '</ul></li>';
        open = false;
    }

    html += '</ul>';

    const contentContainer = document.querySelector('.policy__menu-wrap');

    contentContainer.insertAdjacentHTML('afterbegin', html);

    let offset = document.querySelector('.page-header').getBoundingClientRect().height + 25;

    const contentLi = [...document.querySelectorAll('.policy__menu-wrap li')];

    document.addEventListener('scroll', function() {
        titles.forEach((title, titleIndex) => {
            if (title.getBoundingClientRect().bottom <= offset + 140) {
                contentLi.forEach((liItem, liIndex) => {
                    const isActive = liItem.getAttribute('data-id') === title.querySelector('a[id]').getAttribute('id');

                    if (isActive) {
                        liItem.classList.add('active');
                    } else {
                        liItem.classList.remove('active');
                    }

                    // if (isActive && title.tagName === 'H2') {
                    //     liItem.classList.add('open');
                    // } else if (title.tagName === 'H2') {
                    //     liItem.classList.remove('open');
                    // }
                });
            }
        });
    });

    let links = document.querySelectorAll('.policy__menu-wrap li a');

    links.forEach((link) => {
        link.addEventListener('click', function H(e) {
            let target = this.getAttribute('href');

            e.preventDefault();

            $('html, body').animate({ scrollTop: $(target).offset().top - offset }, 800);
        })
    })
}
menuPolicy();

window.addEventListener('load', function() {
    if (document.querySelector('.policy__menu')) {
        document.querySelector('.policy__menu li').classList.add('active');
    }
});
